import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroComics, comics } from '@/mocks/comics';

const heroItems = [
  {
    ...heroComics[0],
    subtitle: '2026年最受欢迎的浪漫奇幻巨作',
  },
  {
    ...heroComics[1],
    subtitle: '评分9.7！史诗级历史权谋漫画',
  },
  {
    ...heroComics[2],
    subtitle: '韩国漫画平台年度最佳新人奖',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % heroItems.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      {heroItems.map((item, idx) => (
        <div
          key={item.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            idx === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={item.coverImage}
            alt={item.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/30" />
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-14">
            <div className="max-w-7xl mx-auto">
              <div className="max-w-xl">
                <span className="inline-block text-xs px-3 py-1 rounded-full bg-accent-500 text-background-50 font-medium mb-3 whitespace-nowrap">
                  {item.category}
                </span>
                <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-3 leading-tight">
                  {item.title}
                </h2>
                <p className="text-sm md:text-base text-background-200 mb-5 line-clamp-2 leading-relaxed">
                  {item.subtitle}
                </p>
                <Link
                  to={`/comic/${item.id}`}
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  立即阅读
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
        {heroItems.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              idx === current
                ? 'w-8 bg-primary-500'
                : 'bg-background-400/60 hover:bg-background-300'
            }`}
            aria-label={`切换到第${idx + 1}张`}
          />
        ))}
      </div>

      <button
        onClick={next}
        className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 backdrop-blur-sm transition-all duration-200 cursor-pointer z-10"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-background-50 text-lg"></i>
      </button>
      <button
        onClick={() => setCurrent((prev) => (prev - 1 + heroItems.length) % heroItems.length)}
        className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 backdrop-blur-sm transition-all duration-200 cursor-pointer z-10"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-background-50 text-lg"></i>
      </button>
    </section>
  );
}